window.vrDragging = null;

PegasusTemplate.DraggableBaseMixin = Ember.Mixin.create({
  attributeBindings: ['draggable'],
  draggable: function() {
    var result = false;
    if ( this.get('isVrRow') ) {
      result = ! this.get('controller.draggingMuted');
    }
    return "" + result;
  }.property('isVrRow', 'controller.draggingMuted'),

  mouseDown: function(e){
    if ( $(e.target).closest('.cke_editable').length ) {
      Em.run(PegasusTemplate.lookupController('template'), 'set', 'draggingMuted', true);
    } else {
      Em.run(PegasusTemplate.lookupController('template'), 'set', 'draggingMuted', false);
    }

    this._super();
  }
});

